import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const AddProviderPage = lazy(() => import('./AddProviderPage'));

const AddProviderConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.ServiceConfig,
  routes: [
    {
      path: 'providers/add',
      element: <AddProviderPage />,
    },
    {
      path: 'providers/:id/edit',
      element: <AddProviderPage />,
    },
  ],
};

export default AddProviderConfig;
